import { useTranslation } from 'react-i18next';

import { KINS } from '../components/family/Family';
import { useLive } from './live';

/** Who has the trip open, by their initials, and whether its changes come as they happen (the
 * `Live` mockup's bar). */
export function LiveBar() {
  const { t } = useTranslation();
  const { connection, online } = useLive();
  const names = online.map((person) => person.name).join(', ');
  return (
    <div className="bar-live">
      {online.length > 0 && (
        <span
          className="bar-people"
          role="img"
          aria-label={t('live.here', { names })}
          title={names}
        >
          {online.map((person, at) => (
            <span key={person.userId} className={`bar-person kin-${String(at % KINS)}`}>
              {person.name.slice(0, 1).toUpperCase()}
            </span>
          ))}
        </span>
      )}
      <span
        className={`bar-connection bar-connection-${connection}`}
        title={t(`live.state.${connection}`)}
      >
        <span className="bar-connection-name">{t(`live.state.${connection}`)}</span>
      </span>
    </div>
  );
}
